import { render, staticRenderFns } from "./lecturer_detail.vue?vue&type=template&id=b97afe16&scoped=true"
import script from "./lecturer_detail.vue?vue&type=script&lang=js"
export * from "./lecturer_detail.vue?vue&type=script&lang=js"
import style0 from "./lecturer_detail.vue?vue&type=style&index=0&id=b97afe16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97afe16",
  null
  
)

export default component.exports